<template>
  <div id="main">
    <div id="loading" v-show="oe_off">
      <div id="pcload">
        <div id="oebg" v-show="oe_off"></div>
        <div id="load" v-show="oe_off">
          <div id="jiazai">
            <img src="https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E5%8A%A0%E8%BD%BD%E6%9D%A1.png">
            <div id="jiazai_bg" :style="{width:`${520-(load_on*5.2)}px`}"></div>
            <div id="qiu" :style="{marginLeft:`${(load_on)*4.9}px`}">{{load_on}}%</div>
          </div>
        </div>
      </div>
      <div id="phoneload">
        <div id="oebg_m" v-show="oe_off"></div>
        <div id="load_m" v-show="oe_off">
          <div id="jiazai_m">
            <img src="https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E5%8A%A0%E8%BD%BD%E6%9D%A1.png">
            <div id="jiazai_bg_m" :style="{width:`${260-(load_on*2.6)}px`,right:`${6}px`}"></div>
            <div id="qiu_m" :style="{marginLeft:`${(load_on+1.7)*2.4}px`}">{{load_on}}%</div>
          </div>
        </div>
      </div>
    </div>

    <div id="tips" v-show="know">
      <div id="tipsTop"></div>
      <div id="tipsCenter">
        <div id="tipsLeft"></div>
        <div id="tipsZoom">
          <img src="@/assets/ui/鼠标滚轮缩放.png" width="346" height="247" alt="">
          <div></div>
        </div>
        <div id="tipsRotate">
          <img src="@/assets/ui/点击旋转.png" width="245" height="104" alt="">
        </div>
      </div>
      <div id="tipsBottem">
        <div class="tipsKnow" @click="iKonw"></div>
      </div>
    </div>
    <div id="mtips" v-show="know">
      <div id="mtipsTop">
        <img src="@/assets/ui/手机点击旋转.png" width="50%" alt="">
      </div>
      <div id="mtipsCenter">
        <div id="mtipsLeft">
          <img src="@/assets/ui/手机拖拽旋转.png" width="50%" alt="">
        </div>
        <div id="mtipsZoom">
          <img src="@/assets/ui/手机双指缩放.png" width="50%" alt="">
        </div>
      </div>
      <div id="mtipsBottem">
        <div class="tipsKnow" @click="iKonw"></div>
      </div>
    </div>

    <div class="con"></div>
    <div id="pc">
      <div id="mainHead">
        <h1>机械3D交互展示丨原拓数字科技</h1>
<!--        <p>WEB机械，3D机械交互，HTML5，WEBGL</p>-->
      </div>
      <div id="mainBody">
        <div class="bLeft">
          <ul class="leftButton">
<!--            <li class="leftUi" @click="translucent"-->
<!--                :class="{leftUi:translucentHide,leftUiClick:!translucentHide}"><p>半透显示</p></li>-->
            <li class="leftUi" @click="individualHide"
                :class="{leftUi:individual,leftUiClick:!individual}"><p>{{individualText}}</p></li>
<!--            <li class="leftUi" @click="reverseHide"-->
<!--                :class="{leftUiClick: reverseDisplayOff,leftUi:!reverseDisplayOff}"><p>反向显示</p></li>-->
<!--            <li class="leftUi" @click="showMesh"><p>全部显示</p></li>-->
            <li class="leftUi" @click="principleMotion"
                :class="{leftUi:principle,leftUiClick:!principle}"><p>运动原理</p></li>
            <li class="leftUi" @click="manualSplit"
                :class="{leftUi:manualSplitEnable,leftUiClick:!manualSplitEnable}"><p>{{manualSplitText}}</p></li>
            <li class="leftUi" @click="autoDisassemble"
                :class="{leftUi:autoSplit,leftUiClick:!autoSplit}"><p>{{autoSplitText}}</p></li>
          </ul>
        </div>
        <div class="bCenter">
<!--          <div class="centerUiBox">
            <ul class="centerButton">
              <li class="centerUi" @click="oneRestore"><p>一键还原</p></li>
              <li class="centerUi" @click="manualRestore"
                  :class="{centerUiClick: manualRestoreOff,centerUi:!manualRestoreOff}"><p>手动复位</p></li>
              <li class="centerUi" @click="manualSplit"
                  :class="{centerUiClick: manualSplitOff,centerUi:!manualSplitOff}"><p>手动拆分</p></li>
              <li class="centerUi" @click="autoDisassemble"
                  :class="{centerUiClick: autoSplitOff,centerUi:!autoSplitOff}"><p>{{autoSplitText}}</p></li>
            </ul>
          </div>-->
        </div>
        <div class="bRight">
          <ul class="rightButton">
            <a href="https://tb.53kf.com/code/client/ccbfd4f6860544718adf41cbb8f557938/1"><li><img src="@/assets/ui/咨询.png" alt=""></li></a>
            <li @click="autoRotates" class="rightUi" :class="{rightUiClick: autoRotateOff,rightUi:!autoRotateOff}"></li>
          </ul>
        </div>
      </div>
      <div id="mainFoot"></div>
    </div>

    <div id="phone">
      <div id="phoneHead">
        <h4>机械3D交互展示丨原拓数字科技</h4>
<!--        <p>WEB机械，3D机械交互，HTML5，WEBGL</p>-->
      </div>
      <div id="phoneBody">
        <div class="pBodyUi">
          <ul>
            <a href="https://tb.53kf.com/code/client/ccbfd4f6860544718adf41cbb8f557938/1"><li class="phoneBodyUi" ><img src="@/assets/ui/咨询.png" width="40" height="40" alt=""></li></a>
            <li  @click="autoRotates" :class="{mCenterUiClick: autoRotateOff,phoneBodyUi:!autoRotateOff}"></li>
          </ul>
        </div>
      </div>
      <div id="phoneFoot">
        <div class="footUi">
          <div class="footbutten">
            <ul>
<!--              <li class="split" v-show="Splitstatus" @click="splitStatus"><p>拆分状态</p></li>-->
<!--             <li @click="translucent"-->
<!--                  :class="{mleftUiClick: !translucentHide,split:translucentHide}"-->
<!--              ><p>半透显示</p></li>-->
              <li @click="individualHide"
                  :class="{mleftUiClick: !individual,split:individual}"
              ><p>{{individualText}}</p></li>
<!--              <li v-show="Splitstatus" @click="reverseHide"-->
<!--                  :class="{mleftUiClick: reverseDisplayOff,split:!reverseDisplayOff}"-->
<!--              ><p>反向显示</p></li>-->
<!--              <li class="split" @click="showMesh"><p>全部显示</p></li>-->

<!--              <li class="split" v-show="Showstatus" @click="oneRestore"><p>一键还原</p></li>-->
<!--              <li v-show="Showstatus" @click="manualRestore"-->
<!--                  :class="{mleftUiClick: manualRestoreOff,split:!manualRestoreOff}"-->
<!--              ><p>手动还原</p></li>-->
              <li @click="manualSplit"
                  :class="{mleftUiClick: !manualSplitEnable,split:manualSplitEnable}"
              ><p>{{manualSplitText}}</p></li>
              <li @click="autoDisassemble"
                  :class="{mleftUiClick: !autoSplit,split:autoSplit}"><p>{{autoSplitText}}</p></li>
<!--              <li class="split" v-show="Showstatus" @click="mAutoRestore"><p>自动还原</p></li>-->
<!--              <li class="split" v-show="Showstatus" @click="showStatus"><p>返&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;回</p></li>-->
              <li @click="principleMotion"
                  :class="{mleftUiClick: !principle,split:principle}"
              ><p>运动原理</p></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mainApp} from "@/assets/app/script/MainApp";
import wx from 'weixin-jsapi'
import axios from 'axios';
let mainapp;
export default {
  name: "AppMain",
  data(){
    return{
      animater: false,
      loader: null,
      load_on: 0,
      oe_off: true,
      time: null,
      switchUi: true,
      individual: true,
      individualText: "单项隐藏",
      translucentHide: true,
      principle:true,
      manualSplitEnable: true,
      manualSplitText: "手动拆分",
      autoSplit: true,
      autoSplitText: "自动拆分",
      autoRotate: true,
      autoRotateOff: false,
      autoRestore: true,
      objectMusic: null,
      know: false
    }
  },
  beforeDestroy() {
    if(mainapp){
      mainapp.clean();
      mainapp=null;
      mainapp.clearAnimate();
      console.log("销毁");
    }
  },
  methods: {

    destroy(){
      this.individual = true;//单项隐藏
      this.individualText = "单项隐藏"
      this.translucentHide= true;//半透明
      this.principle=true;//运动原理
      this.manualSplitEnable= true;//手动拆分
      this.manualSplitText = "手动拆分"
      this.autoSplit= true;//自动拆分
      this.autoSplitText= "自动拆分";//自动拆分文字
      this.autoRotate= true;//自动旋转
      this.autoRotateOff= false;//自动旋转样式
    },
    init(){
      let mainContent = document.querySelector(".con");
      mainapp = new mainApp(mainContent);
    },
    addmodel(){
      let self = this;
      mainapp.loadModel(`${process.env.BASE_URL}model/wurenjiwurenji.glb`,loaded=>{
        self.loader = loaded;
       self.loading(loaded);
        //mainapp.addHotspot("0");
        // mainapp.createHotspot("0",{x:0,y:0,z:0.4},0.1,()=>{
        //   self.briefIntroduction = true;
        // });
      });
      mainapp.update();
    },
    loading(index){
      let self =this;
      // self.load_on = Number(index*2.777777777777778).toFixed(0);
      self.load_on = index;
      if(index === 100){
        if(self.time === null){
          self.time = setTimeout(function () {
            self.oe_off = false;
            self.know = true;
            clearTimeout(self.time);
          },500);
        }
      }
    },
    iKonw() {
      this.know = false;
    },
    playMusic(){
      this.objectMusic.play();
    },
    createAudio() {
      this.objectMusic = new Audio();
      this.objectMusic.src = `${process.env.BASE_URL}music/点击音效.wav`;
      this.objectMusic.loop = false;
      document.body.appendChild(this.objectMusic);
    },
    /**
     * 运动原理
     */
    principleMotion(){
      if(this.switchUi&&this.manualSplitEnable&&this.autoSplit&&this.individual&&this.translucentHide&&this.principle){
        this.principle = false;
        this.switchUi = false;
        this.playMusic();
        mainapp.principleMotion(true);
      }else {
        if(!this.principle){
          this.oneRestore();
          this.principle = true;
          this.switchUi = true;
          this.playMusic();
          mainapp.principleMotion(false);
        }
      }
    },
    /**
     * 一键还原
     */
    oneRestore(){
      mainapp.oneRestore();//还原
      mainapp.showMesh();//全部显示
    },
    /**
     * 手动还原
     */
    /*manualRestore(){
      if(this.manualRestoreEnable&&this.manualSplitOff){
        this.manualRestoreEnable = false;
        this.manualRestoreOff = true;
        mainapp.manualRestore(true);
        mainapp.individualHide(false);
        mainapp.manualSplit(false);
        //mainapp.translucent(false);
        this.translucentHideOff = false;
        this.individualOff = false;
        this.reverseDisplayOff = false;
        // this.principleOff = false;
        this.manualSplitOff = false;
        this.individual = true;
        this.manualSplitEnable = true;
        this.translucentHide = true;
        // this.principle = true;
        this.reverseDisplay = true;
      }else {
        mainapp.manualRestore(false);
        this.manualRestoreEnable = true;
        this.manualRestoreOff = false;
      }

    },*/
    /**
     * 手动拆分
     */
    manualSplit(){
      if(this.switchUi&&this.manualSplitEnable&&this.autoSplit&&this.individual&&this.translucentHide&&this.principle){
        this.switchUi = false;
        this.manualSplitEnable = false;
        this.manualSplitText = "一键还原";
        this.playMusic();
        mainapp.manualSplit(true);
      }else {
        if(!this.manualSplitEnable){
          this.oneRestore();
          this.manualSplitEnable = true
          this.switchUi = true;
          this.manualSplitText = "手动拆分";
          this.playMusic();
          mainapp.manualSplit(false);
        }
      }

    },
    /**
     * 全部显示
     */
    showMesh(){
      mainapp.showMesh();
    },
    /**
     * 半透明
     */
    translucent(){
      if(this.switchUi&&this.manualSplitEnable&&this.autoSplit&&this.individual&&this.translucentHide&&this.principle){
        this.switchUi = false;
        this.translucentHide = false;
        this.playMusic();
        mainapp.translucent(true);
      }else {
        if(!this.translucentHide){
          this.switchUi = true;
          this.translucentHide = true;
          this.playMusic();
          mainapp.translucent(false);
        }

      }

    },
    /**
     * 单项隐藏
     */
    individualHide(){
      if(this.switchUi&&this.manualSplitEnable&&this.autoSplit&&this.individual&&this.translucentHide&&this.principle){
        this.switchUi = false;
        this.individual = false;
        this.individualText = "全部显示";
        this.playMusic();
        mainapp.individualHide(true);
      }else {
        if(!this.individual){
          this.individual = true;
          this.switchUi = true;
          this.individualText = "单项隐藏";
          mainapp.individualHide(false);
          this.playMusic();
          this.showMesh();
        }
      }

    },
    /**
     * 反向隐藏
     */
    /*reverseHide(){
      if(this.reverseDisplay){
        this.reverseDisplay = false;
        this.reverseDisplayOff = true;
        mainapp.reverseHide();
        mainapp.individualHide(false);
        mainapp.manualRestore(false);
        mainapp.manualSplit(false);
        //mainapp.translucent(false);
        this.translucentHideOff = false;
        this.individualOff = false;
        // this.principleOff = false;
        this.manualRestoreOff = false;
        this.manualSplitOff = false;
        this.individual = true;
        this.manualRestoreEnable = true;
        this.manualSplitEnable = true;
        this.translucentHide = true;
        // this.principle = true;
      }else {
        this.reverseDisplay = true;
        this.reverseDisplayOff = false;
        mainapp.reverseHide();
      }

    },*/
    /**
     * 自动拆分
     */
    autoDisassemble() {
      let self = this;
      if (self.switchUi&&self.manualSplitEnable&&self.autoSplit&&self.individual&&self.translucentHide&&self.principle&&self.autoRestore){
        mainapp.autoDisassemble(true,restore=>{
          self.autoRestore = restore;
          self.switchUi = false;
        });
        self.autoSplitText = "自动还原";
        self.playMusic();
        self.autoSplit = false;
      } else if(self.autoRestore&&!self.switchUi&&!self.autoSplit){
        if(!self.autoSplit){
          mainapp.autoDisassemble(false,restore=>{
            self.autoRestore = restore;
            self.switchUi = restore;
          });
          self.autoSplitText = "自动拆分";
          self.playMusic();
          self.autoSplit = true;
        }

      }
    },
    /*mAutoDisassemble(){
        if(this.autoSplit){
          mainapp.autoDisassemble(true);
          this.autoSplit = false;
          this.autoSplitOff = true;
          this.translucentHideOff = false;
          this.individualOff = false;
          this.reverseDisplayOff = false;
          this.principleOff = false;
          this.manualRestoreOff = false;
          this.manualSplitOff = false;
          this.individual = true;
          this.manualRestoreEnable = true;
          this.manualSplitEnable = true;
          this.translucentHide = true;
          this.principle = true;
          this.reverseDisplay = true;
        }
    },
    mAutoRestore(){
      if(!this.autoSplit){
        mainapp.autoDisassemble(false);
        this.autoSplit = true;
        this.autoSplitOff = false;
        this.translucentHideOff = false;
        this.individualOff = false;
        this.reverseDisplayOff = false;
        this.principleOff = false;
        this.manualRestoreOff = false;
        this.manualSplitOff = false;
        this.individual = true;
        this.manualRestoreEnable = true;
        this.manualSplitEnable = true;
        this.translucentHide = true;
        this.principle = true;
        this.reverseDisplay = true;
      }

    },*/
    /**
     * 自动旋转
     */
    autoRotates(){
      if(this.autoRotate){
        mainapp.autoRotates(true);
        this.autoRotate = false;
        this.autoRotateOff = true;
        this.playMusic();
      }else{
        mainapp.autoRotates(false);
        this.autoRotate = true;
        this.autoRotateOff = false;
        this.playMusic();
      }
    },
    /**
     * 播放动画
     */
    playAnimater(){

      mainapp.playAnimater(1);

    },
    /**
     * 停止动画
     */
    unPlayAnimater(){

      mainapp.playAnimater(0);

    },

    share(){
      let self = this;
      axios.post("https://www.vg3dy.com/api/wx/wxShareSignature",
          {url:location.href.split('#')[0]}
      ).then(data=>{
        this.res = data.data;
        wx.config({
          debug: false, // 是否开启调试模式
          appId: self.res&&self.res.appId, //appid
          timestamp: self.res&&self.res.timestamp, // 时间戳
          nonceStr: self.res&&self.res.nonceStr, // 随机字符串，只有这个是驼峰?
          signature: self.res&&self.res.signature, // 签名
          jsApiList: [
            'onMenuShareAppMessage','onMenuShareTimeline'
          ] // 需要使用的JS接口列表
        });

        wx.ready(function (){

          wx.onMenuShareTimeline({
            title:"机械3D交互展示",
            link:location.href.split('#')[0],
            imgUrl:"https://oe-object.obs.cn-north-4.myhuaweicloud.com/WEB3D/anli/External/officialWebsitePorject/wurenji/wurenji.png",
            success: function (){
              //self.weixinoff();
            },
            cancel: function () {
              console.log(222);
              alert(222);
            }
          });
          wx.onMenuShareAppMessage({
            title:"机械3D交互展示",
            desc:"采用WEBGL技术，720对产品模型进行全方位展示，交互热点可对模型进行手动以及自动拆分、工作原理展示、零件单独展示。在网页上轻松实现交互，一键转发快速扩散。",
            link:location.href.split('#')[0],
            imgUrl:"https://oe-object.obs.cn-north-4.myhuaweicloud.com/WEB3D/anli/External/officialWebsitePorject/wurenji/wurenji.png",
            type:"link",
            dataUrl:"",
            success:function (){
             // self.weixinoff();
            },
            cancel: function (){
              alert("取消")
            }
          });
        });

        wx.error(function(res){
          alert("错误："+res);//错误提示
        });
      });
    },
  },
  mounted() {
    this.init();
    this.addmodel();
    this.share();
    this.createAudio();
  }
}
</script>

<style scoped>


/*#xm_loading{*/
/*  width: 100vw;*/
/*  height: 100vh;*/
/*  background: url("~@/assets/ui/bg.jpg") center center no-repeat;*/
/*  position: absolute;*/
/*  top: 0;*/
/*  z-index: 100;*/
/*}*/
#main{
  width: 100vw;
  height: 100vh;

}
/*加载页面*/
#loading{
  width: 100%;
  height: 100%;
  position: relative;

}
#pcload{
  display: block;
}
#phoneload{
  display: none;
}
#load{
  background: url("https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E7%94%B5%E8%84%91%E7%AB%AF%E8%83%8C%E6%99%AF.jpg") center center no-repeat;
  background-size:100% 100%;
  position: absolute;
  top: 0;
  z-index: 500;
  height: 100%;
  width: 100%;
}
#jiazai{
  width: 540px;
  height: 60px;
  position: absolute;
  z-index: 101;
  top: 77%;
  left: 50%;
  margin-left: -270px;
}
#jiazai_bg{
  width: 530px;
  height: 42px;
  background: black;
  position: absolute;
  top: 9%;
  border-radius: 20px;
  right: 11px;
  transform: rotate(180deg);
  z-index: 105;
}

#oebg{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 120;
  background: #090B3C;
}

#qiu{
  width: 42px;
  height: 42px;
  background: url("https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E5%8A%A0%E8%BD%BD%E7%90%83.png") center center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 0;
  /*margin-left: 63px;*/
  margin-top:-24px;
  line-height: 42px;
  color: black;
  text-align: center;
  font-size: 1rem;
}
/*加载页面*/


/*提示页面*/
#mtips{
  display: none;
}
#tips{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 999;
  top: 0;
  background: rgba(0,0,0,0.7);
}
#tipsTop{
  width: 100%;
  height: 30%;
}
#tipsCenter{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
#tipsBottem{
  width: 100%;
  height: 300px;
}
#tipsLeft{
  width: 350px;
  height: 100%;
}
#tipsRotate{
  width: 500px;
  height: 100%;
  position: relative;
}
#tipsRotate img{
  width: 245px;
  height: 104px;
  z-index: 999;
  margin-top: 30%;
  margin-left: 15%;
}
#tipsZoom{
  width: 60%;
  height: 100%;
  position: relative;
}
#tipsZoom img{
  width: 346px;
  height: 247px;
  position: relative;
  top: 30%;
  left: 41%;
}
.tipsKnow{
  width: 245px;
  height: 104px;
  background: url("~@/assets/ui/我知道了.png") center no-repeat;
  cursor: pointer;
  pointer-events: auto;
  margin: 0 auto;
}
/*提示页面*/

#pc{
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/底色.png") center no-repeat;
  display: flex;
  flex-direction: column;
}
#mainHead{
  width: 100%;
  height: 200px;
  background: url("~@/assets/ui/标题.png") top no-repeat;
  color: #fff;
  text-align: center;
  font-family: 微软雅黑;
  line-height: 80px;
}

.clickEnable{
  pointer-events: none;
  cursor:pointer;
}
#mainBody{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  text-align: center;
}
.bLeft{
  width: 350px;
  height: 100%;
  position: relative;
}
.leftButton{
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
  top: 40%;
  left: 50%;
  margin-top: -50%;
  margin-left: -50%;
}
.leftUi{
  margin-bottom: 20px;
  pointer-events: auto;
  cursor:pointer;
  list-style-type:none;
  background: url("~@/assets/ui/无字.png") center no-repeat;
  width: 203px;
  height: 65px;
  text-align: center;
  line-height: 65px;
  margin-left: 20px;
}
.leftUi:hover{
  margin-left: 3px;
  filter:alpha(opacity=20);
  opacity: 0.6;
}

.leftUi p{
  color: white;
  letter-spacing: 10px;
}

.bCenter{
  width: 60%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.centerUiBox{
  width: 675px;
  height: 67px;
  position: absolute;
  z-index: 100;
  top: 5%;
  left: 50%;
  margin-left: -337.5px;
  background: url("~@/assets/ui/拆分左右装饰.png") center no-repeat;
  z-index: 100;
}
.centerButton{
  display: table;
  margin: 14px auto;
}
/*centerButton::after {
  content: '';
  display: inline-block;
  clear: both;
}*/
.centerUi{
  float: left;
  pointer-events: auto;
  cursor:pointer;
  margin-left: 5px;
  text-align: center;
  background: url("~@/assets/ui/自动拆分无字.png");
  width: 132px;
  height: 39px;
  line-height: 39px;
  list-style-type:none;
}
.centerUi:hover{
  margin-top: -1px;
  filter:alpha(opacity=20);
  opacity: 0.6;
}
.centerUi p{
  color: white;
  letter-spacing: 10px;
}
.con{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 15;
}
.bRight{
  width: 500px;
  height: 100%;
  position: relative;
  z-index: 999;
}
.rightButton{
  width: 100%;
  height: 100%;
  z-index: 100;
  margin-left: 60%;
}
.rightButton li{
  margin-bottom: 20px;
  pointer-events: auto;
  width: 99px;
  height: 101px;
  cursor:pointer;
  list-style-type:none;
  margin-left: 30px;
}
.rightUi{
  background: url("~@/assets/ui/旋转.png") center no-repeat;
  background-size: 100% 100%;
  width: 99px;
  height: 101px;
  pointer-events: auto;
  margin-left: 30px;
  cursor:pointer;
  list-style-type:none;
}
.rightButton li:hover{
  margin-left: 33px;
  filter:alpha(opacity=20);
  opacity: 0.6;
}
#mainFoot{
  width: 100%;
  height: 100px;
}
/*点击后样式*/
.leftUiClick{
  background: url("~@/assets/ui/无字选中.png") center no-repeat;
}
.centerUiClick{
  background: url("~@/assets/ui/自动拆分无字选中.png") center no-repeat;
}
.rightUiClick{
  background: url("~@/assets/ui/旋转高亮.png") center no-repeat;
}

/**/
#phone{
  display: none;
}

@media screen and (max-width: 1300px) {
  #tipsRotate img{
    width: 245px;
    height: 104px;
    z-index: 999;
    margin-top: 40%;
    margin-left: 5%;
  }
  #tipsZoom img{
    width: 346px;
    height: 247px;
    position: relative;
    top: 30%;
    left: 33%;
  }
}
@media screen and (max-width: 1160px) {
  #tipsRotate img{
    width: 245px;
    height: 104px;
    z-index: 999;
    margin-top: 45%;
    margin-left: 3%;
  }
  #tipsZoom img{
    width: 346px;
    height: 247px;
    position: relative;
    top: 30%;
    left: 30%;
  }
}

@media screen and (max-width:600px){

  /*加载界面*/
  #pcload{
    display: none;
  }
  #phoneload{
    display: block;
  }
  #load_m{
    background: url("https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E6%89%8B%E6%9C%BA%E7%AB%AF%E8%83%8C%E6%99%AF.jpg") center center no-repeat;
    background-size:100% 100%;
    position: absolute;
    top: 0;
    z-index: 100;
    height: 100%;
    width: 100%;
  }

  #jiazai_m{
    width: 270px;
    height: 30px;
    position: absolute;
    z-index: 101;
    top: 70%;
    left: 50%;
    margin-left: -135px;
  }
  #jiazai_m>img{
    width: 100%;
    height: 100%;
  }
  #jiazai_bg_m{
    width: 258px;
    height: 22px;
    /*background: url("~@/assets/UI/加载条_H.png") no-repeat;*/
    /*background-size: 100% 100%;*/
    background-color: black;
    position: absolute;
    top: 9%;
    transform: rotate(180deg);
    border-radius: 11px;
    z-index: 105;
  }
  #qiu_m{
    width: 21px;
    height: 21px;
    background: url("https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E5%8A%A0%E8%BD%BD%E7%90%83.png") center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    z-index: 999;
    top: 50%;
    left: 0;
    /*margin-left: 63px;*/
    margin-top:-12px;
    line-height: 21px;
    color: black;
    text-align: center;
    font-size: 0.5rem;
  }
  #oebg_m{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 80;
    background: #015EC5;
  }
  /*加载界面*/

  /*提示界面*/
  #tips{
    display: none;
  }
  #mtips{
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0,0,0,0.7);
    z-index: 999;
    display: flex;
    flex-direction: column;
  }
  #mtipsTop{
    width: 100%;
    height: 270px;
  }
  #mtipsTop img{
    margin-top: 43%;
    margin-left: 32%;
  }
  #mtipsCenter{
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
  }
  #mtipsLeft{
    width: 50%;
    height: 200px;
    position: absolute;
    left: 20%;
    top: 35%;
  }
  #mtipsZoom{
    width: 50%;
    height: 200px;
    position: absolute;
    left: 60%;
    top: 35%;
  }
  #mtipsBottem{
    width: 100%;
    height: 300px;
  }
  .tipsKnow{
    width: 196px;
    height: 83px;
    background: url("~@/assets/ui/手机我知道了.png") center no-repeat;
    background-size: 100% 100%;
    z-index: 999;
    cursor: pointer;
    pointer-events: auto;
    margin: 0 auto;
  }
  /*提示界面*/

  .clickEnable{
    pointer-events: none;
    cursor:pointer;
  }
  .mleftUiClick{
    background: url("~@/assets/ui/无字选中.png") center no-repeat;
    float: left;
    pointer-events: auto;
    cursor:pointer;
    margin-left: 43px;
    margin-bottom: 20px;
    text-align: center;
    background-size: 100% 100%;
    width: 132px;
    height: 39px;
    line-height: 37px;
    list-style-type:none;
  }
  .mleftUiClickAuto{
    background: url("~@/assets/ui/无字选中.png") center no-repeat;
    float: left;
    pointer-events: auto;
    cursor:pointer;
    margin-left: 32%;
    margin-bottom: 20px;
    text-align: center;
    background-size: 100% 100%;
    width: 132px;
    height: 39px;
    line-height: 37px;
    list-style-type:none;
  }
  .mCenterUiClick{
    width: 40px;
    height: 40px;
    background: url("~@/assets/ui/旋转高亮.png") center no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    pointer-events: auto;
    cursor: pointer;
  }
  .mCenterUiClick{
    width: 40px;
    height: 40px;
    background: url("~@/assets/ui/旋转高亮.png") center no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    pointer-events: auto;
    cursor: pointer;
  }
  #pc{
    display: none;
  }
  #main{
    width: 100vw;
    height: 100vh;
  }
  #phone{
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/底色.png") center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
  }
  #phoneHead{
    width: 100%;
    height: 80px;
    background: url("~@/assets/ui/标题手机.png") center no-repeat;
    background-size: 100% 100%;
    color: #fff;
    text-align: center;
    font-family: 微软雅黑;
    line-height: 45px;
  }
  #phoneBody{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .con{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10;
    top: -7%;
  }
  #phoneBody ul{
    position: absolute;
    z-index: 50;
    right: 30px;
    top: 50px;
  }
  .phoneBodyUi{
    width: 40px;
    height: 40px;
    background: url("~@/assets/ui/旋转.png") center no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    pointer-events: auto;
    cursor: pointer;
  }
  #phoneFoot{
    width: 100%;
    height: 600px;
    display: flex;
    flex-direction: row;
  }
  .footUi{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .footbutten{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .footbutten p{
    color: white;
    letter-spacing: 3px;
  }
  .footbutten ul{
    display: table;
    margin: 0px auto;
    position: absolute;
    top: 17%;
    z-index: 100;
  }
  .split{
    float: left;
    pointer-events: auto;
    cursor:pointer;
    margin-left: 43px;
    margin-bottom: 20px;
    text-align: center;
    background: url("~@/assets/ui/无字.png") center no-repeat;
    background-size: 100% 100%;
    width: 132px;
    height: 39px;
    line-height: 37px;
    list-style-type:none;
  }
  .splitauto{
    float: left;
    pointer-events: auto;
    cursor:pointer;
    margin-left: 32%;
    margin-bottom: 20px;
    text-align: center;
    background: url("~@/assets/ui/无字.png") center no-repeat;
    background-size: 100% 100%;
    width: 132px;
    height: 39px;
    line-height: 37px;
    list-style-type:none;
  }

  html{
    width: 100vw;
    height: 100vh;

  }
  body{
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/底色.png");
  }
}
</style>
